export default __webpack_public_path__ + "static/media/cert-hkgcsmeaa.5b1ace4a.jpg";